
enum AlertScheduleType {
    TRIGGERED="TRIGGERED", SCHEDULED="SCHEDULED"
}

export default AlertScheduleType;